import { render, staticRenderFns } from "./post-downloader.vue?vue&type=template&id=67f86e9b&scoped=true"
import script from "./post-downloader.vue?vue&type=script&lang=js"
export * from "./post-downloader.vue?vue&type=script&lang=js"
import style0 from "./post-downloader.vue?vue&type=style&index=0&id=67f86e9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f86e9b",
  null
  
)

export default component.exports